const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function staffInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] ?? ""}${parts[1]![0] ?? ""}`.toUpperCase();
}

export function formatShiftRange(start: string, end: string, timeZone?: string): string {
  const opts: Intl.DateTimeFormatOptions = {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: timeZone || undefined,
  };
  const s = new Date(start);
  const e = new Date(end);
  const sameDay = s.toDateString() === e.toDateString();
  const startStr = s.toLocaleString(undefined, opts);
  const endOpts: Intl.DateTimeFormatOptions = sameDay
    ? { hour: "numeric", minute: "2-digit", timeZone: timeZone || undefined }
    : opts;
  const endStr = e.toLocaleString(undefined, endOpts);
  return `${startStr} – ${endStr}`;
}

export function formatTime(iso: string, timeZone?: string): string {
  return new Date(iso).toLocaleString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    month: "short",
    day: "numeric",
    timeZone: timeZone || undefined,
  });
}

export function dayName(dayOfWeek: number): string {
  return DAY_NAMES[dayOfWeek] ?? `Day ${dayOfWeek}`;
}

export function formatHourlyRate(rate: string | null): string {
  if (!rate) return "—";
  const n = Number(rate);
  if (Number.isNaN(n)) return rate;
  return `$${n.toFixed(2)}/hr`;
}

export function categoryLabel(category: string): string {
  return category
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
